require('./_set-species')('Array');


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/~/core-js/modules/es6.array.species.js
 ** module id = 191
 ** module chunks = 12
 **/